import React from 'react';
import {DefaultTheme as PaperDefaultTheme} from 'react-native-paper';
import {DefaultTheme as NavigationDefaultTheme} from '@react-navigation/native';

const combinedDefaultTheme = {
    ...NavigationDefaultTheme,
    ...PaperDefaultTheme,
    colors: {
		...NavigationDefaultTheme.colors,
		...PaperDefaultTheme.colors,
        primary: '#ececec',
        success: '#155724',
        accent: '#f9bc0d',
        errors: {
            default: '#f86962',
            light: '#f8d7da',
            dark: '#721c24'
        },
        warnings: {
            default: '#f6d46f',
            light: '#fff4d2',
            dark: '#e2ad08'
        },
		successes: {
            default: '#ccffcc',
            light: '#d4edda',
            dark: '#155724'			
		},
		infos: {
            default: '#cce5ff',
            light: '#cce5ff',
            dark: '#004085'			
		},
        button: {
            primary: '#2d9cdb',
            secondary: '#f2994a',
            success: '#4cb964',
            textLight: '#ffffff',
            textDark: '#282828'
        },
        tab: {
            active: '#f2994a'
        },
        switch: '#4cd964'
    },
    statusBarStyle: 'dark-content'
};

export default combinedDefaultTheme;